// extracted by mini-css-extract-plugin
export default {"column-filter--active":"styles_column-filter--active__Xa8VE"};